import {
  deleteApiAlbumCollectionsId,
  deleteApiAlbumCollectionsIdAlbums,
  getApiAlbumCollectionsId,
  postApiAlbumCollections,
  postApiAlbumCollectionsIdAlbums,
  putApiAlbumCollectionsId,
  putApiAlbumCollectionsIdAlbumsOrder,
} from '@/shared/api'
import { createMutation, createQuery } from '@farfetched/core'

export const albumCollectionByIdQuery = createQuery({
  handler: getApiAlbumCollectionsId,
})

export const albumCollectionCreate = createMutation({
  handler: postApiAlbumCollections,
})

export const albumCollectionUpdate = createMutation({
  handler: putApiAlbumCollectionsId,
})

export const albumCollectionDelete = createMutation({
  handler: deleteApiAlbumCollectionsId,
})

export const albumCollectionAddAlbum = createMutation({
  handler: postApiAlbumCollectionsIdAlbums,
})

export const albumCollectionOrderAlbums = createMutation({
  handler: putApiAlbumCollectionsIdAlbumsOrder,
})

export const albumCollectionDeleteAlbum = createMutation({
  handler: deleteApiAlbumCollectionsIdAlbums,
})
